import { useSelector } from "react-redux";
import { resolveImportStageFromState } from "../helpers/importStageHelper";
import { isFlowEngineEnabledForProcess } from "../helpers/flowEngineConfigHelper";
import { isCasePhaseTableField, prependCasePhaseField } from "../helpers/flowModuleListUiHelper";

const keepTableField = (item, isPreManager) => {
  if (!item) {
    return false;
  }
  if (item.data_type === "buttons") {
    return true;
  }
  return isPreManager ? item.show_in_table_pre === true : true;
};

const normalizeTableField = (item, isPreManager) => {
  if (item.data_type === "buttons") {
    return { ...item, show_in_table: true };
  }
  if (isPreManager) {
    return { ...item, show_in_table: true };
  }
  return item;
};

const useModuleTableFields = (moduleKey, gestorList = []) => {
  const userRole = useSelector((state) => state.userRole);
  const configuration = useSelector((state) => state.configuration);
  const isPreManager = resolveImportStageFromState({ userRole }) === "pre";
  const flowOn = isFlowEngineEnabledForProcess(configuration, moduleKey);
  const rawFields = (gestorList || [])
    .filter((item) => keepTableField(item, isPreManager))
    .map((item) => normalizeTableField(item, isPreManager));
  if (!flowOn) {
    return rawFields.filter((item) => !isCasePhaseTableField(item));
  }
  return prependCasePhaseField(rawFields);
};

export default useModuleTableFields;
